import { LayoutDashboardIcon, ArrowDownCircle, Package, History } from "lucide-react";
import { useAppSelector } from "../../../features/helpers";

import {
    PageCard, SectionTitle, EmptyState, KpiCard, HeroBalance,
} from "../../../components/ui";

const SupplierHome = () => {

    const userInfo = useAppSelector((s) => s.user.userInfo);

    return (
        <div className="home-wrapper">
            <div className="dashboard">

                <h1 className="title">
                    <div>
                        <LayoutDashboardIcon size={24} className="icon" /> Area do Fornecedor
                    </div>
                    <small>painel com seus envios, recebimentos e historico.</small>
                </h1>

                <HeroBalance
                    label="Em aberto com a organizacao"
                    balance={0}
                    actions={
                        <button className="btn-pill primary">
                            <ArrowDownCircle size={16} /> Registrar entrega
                        </button>
                    }
                />

                <section className="kpi-row" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16, marginBottom: 32 }}>
                    <KpiCard variant="success" icon={Package}  label="Entregas no mes"   value="0" />
                    <KpiCard variant="info"    icon={History}  label="Total entregue"    value="—" />
                    <KpiCard variant="warn"    icon={ArrowDownCircle} label="Aguardando"  value="—" />
                </section>

                <PageCard>
                    <SectionTitle icon={History}>Historico de entregas</SectionTitle>
                    <EmptyState
                        icon={Package}
                        title="Sem entregas registradas ainda."
                        description={`Quando voce registrar entregas elas aparecerao aqui, ${userInfo?.name || ""}.`}
                    />
                </PageCard>

            </div>
        </div>
    );
};

export default SupplierHome;
